import type { IconProps } from '../../types';

import FilledSVG from './icon-fill.svg';
import OutlinedSVG from './icon.svg';

export const RadioButtonCheckedSVG = (opts?: IconProps): string => {
  const variant = opts?.variant ?? 'filled';

  return variant === 'outlined' ? OutlinedSVG : FilledSVG;
};

export default RadioButtonCheckedSVG;
